import { atomWithStorage, createJSONStorage } from 'jotai/utils'

import type { CityModel } from '@/shared/api'

const persistentStorage = createJSONStorage<CityModel | null>(() => localStorage)

export const authCityAtom = atomWithStorage<CityModel | null>(
    '@taxoparkee/city',
    null,
    persistentStorage,
    {
        getOnInit: true,
    }
)
